import React, { useState, useRef, useEffect } from 'react';
import Logo from './Logo';
import './ImageUploader.css';
import { useLoaderStore } from '../stores/loaderStore.ts';
import Loader from './Loader/Loader.tsx';
import { LuUpload } from 'react-icons/lu';
import { AnalyticsTracker } from '../Utils/analytics-tracker';
import { ANALYTICS_SOURCES, EVENTS } from '../Utils/constant.js';

// Launch New Collections Without Studio Costs
// Drop New Looks in Hours. Not Weeks
// Close Buyers Without a Single Photoshoot

// "https://tryon.avataar.ai/slug=launch-new-collections"
// "https://tryon.avataar.ai/slug=drop-new-looks-in-hours"
// "https://tryon.avataar.ai/slug=close-buyers-without-a-single-photoshoot"

const titleMap = {
    'launch-new-collections': {
        title1: 'Launch ',
        title2: 'New Collections Without Studio Costs',
    },
    'drop-new-looks-in-hours': {
        title1: 'Drop ',
        title2: 'New Looks in Hours. Not Weeks',
    },
    'close-buyers-without-a-single-photoshoot': {
        title1: 'Close ',
        title2: 'Buyers Without a Single Photoshoot',
    },
    'create-runway-ready-visuals': {
        title1: 'Create ',
        title2: 'Runway-Ready Visuals',
    },
};

const MediaUploader = () => {
    const [files, setFiles] = useState([]);
    const [files2, setFiles2] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [previews2, setPreviews2] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [results, setResults] = useState([]);
    const { setShowLoader } = useLoaderStore();
    const input1Ref = useRef(null);
    const input2Ref = useRef(null);
    const [videoLoading, setVideoLoading] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);
    const [videoError, setVideoError] = useState(null);

    const [titleData, setTitleData] = useState({
        title1: '',
        title2: '',
    });

    useEffect(() => {
        // Get search params using native URLSearchParams
        const urlParams = new URLSearchParams(window.location.search);
        let slug = urlParams.get('slug');

        if (slug) {
            window.localStorage.setItem('slug', slug);
            // Remove slug from URL without refreshing the page
            const newUrl = window.location.pathname + window.location.hash;
            window.history.replaceState({}, '', newUrl);
        } else slug = window.localStorage.getItem('slug');

        let pageTitle = titleMap['create-runway-ready-visuals'];
        if (slug) pageTitle = titleMap[slug] ?? titleMap['create-runway-ready-visuals'];
        setTitleData(pageTitle);
    }, []);

    const handleFileChange = (e) => {
        AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.UPLOAD_MODEL);
        if (results.length > 0) {
            // Only clear if there are results (meaning previous process is complete)
            setResults([]);
            setFiles([]);
            setPreviews([]);
        }

        const selectedFiles = Array.from(e.target.files);
        console.log(selectedFiles);
        setFiles((prevFiles) => [
            // ...prevFiles,
            ...selectedFiles,
        ]);

        // Generate previews for new files
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviews((prev) => [
                    // ...prev,

                    {
                        name: file.name,
                        url: reader.result,
                    },
                ]);
            };
            reader.readAsDataURL(file);
        });
        if (input1Ref.current) {
            input1Ref.current.value = '';
        }
    };

    const handleFileChangeForClothes = (e) => {
        AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.UPLOAD_CLOTHES);
        if (results.length > 0) {
            // Only clear if there are results (meaning previous process is complete)
            // setResults([]);
            setFiles2([]);
            setPreviews2([]);
        }

        const selectedFiles = Array.from(e.target.files);
        setFiles2((prevFiles) => [
            // ...prevFiles,
            ...selectedFiles,
        ]);

        // Generate previews for new files
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviews2((prev) => [
                    // ...prev,
                    {
                        name: file.name,
                        url: reader.result,
                    },
                ]);
            };
            reader.readAsDataURL(file);
        });

        if (input2Ref.current) {
            input2Ref.current.value = '';
        }
    };

    const removeFile = (index) => {
        setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    };

    const removeFileForClothes = (index) => {
        setFiles2((prevFiles) => prevFiles.filter((_, i) => i !== index));
        setPreviews2((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    };

    const handleUpload = async () => {
        if (Array.isArray(window?.dataLayer)) {
            window?.dataLayer?.push({
                event: 'Try On Image Generation Click',
                element_id: 'generate-tryon-image-button',
            });
        }
        const ip = await fetch('https://api.ipify.org/?format=json');
        const ipData = await ip.json();
        AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.GENERATE_IMAGE, {
            ip: ipData.ip,
        });
        setLoading(true);
        setError(null);
        setShowLoader(true, 'Generating tryon image... This may take a minute');
        setResults([]);

        try {
            const formData = new FormData();

            files.forEach((file) => {
                formData.append('model', file);
            });

            files2.forEach((file) => {
                formData.append('clothes', file);
            });

            formData.append('ip', ipData.ip);
            // formData.append("imageCount", files.length);
            // formData.append("CustomField", "This is some extra data");

            const response = await fetch('https://avataar-kube.avataar.ai/tryon/generate_tryon', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                // Attempt to read the error message from the response body
                let errorMessage = `Upload failed with status: ${response.status}`;
                try {
                    const errorData = await response.json();
                    // Assuming the error response has a 'message' or 'error' field
                    errorMessage =
                        errorData.message || errorData.error || JSON.stringify(errorData);
                } catch (jsonError) {
                    // If the response body is not JSON or empty, use the status text
                    errorMessage = `Upload failed: ${response.status} ${response.statusText}`;
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();

            const result = {
                // id: data.session_id,
                // glbUrl: data.glb_model,
                // videoUrl: data.preview_video,
                imageUrl: data.image,
            };

            AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.IMAGE_GENERATION_SUCCESS, {
                imageUrl: result.imageUrl,
                ip: ipData.ip,
            });

            setResults([result]);
            setLoading(false);
            setShowLoader(false);
            // Removed the clearing of files and previews here
        } catch (err) {
            AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.IMAGE_GENERATION_ERROR, {
                errorMessage: err.message,
            });
            setError(err.message);
            setLoading(false);
            setShowLoader(false);
        }
    };

    const handleGenerateVideo = async () => {

        if (Array.isArray(window?.dataLayer)) {
            window?.dataLayer?.push({
                event: 'Try On Video Generation Click',
                element_id: 'generate-video-button',
            });
        }
        const ip = await fetch('https://api.ipify.org/?format=json');
        const ipData = await ip.json();
        AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.GENERATE_VIDEO, {
            ip: ipData.ip,
        });
        setVideoLoading(true);
        setVideoError(null);
        setShowLoader(true, 'Generating video... Please wait');

        try {
            const imageUrl = encodeURIComponent(results[0].imageUrl); // Ensure the URL is properly encoded
            const url = `https://avataar-kube.avataar.ai/tryon/generate_video?tryon_image=${imageUrl}&ip=${ipData.ip}`;

            const response = await fetch(url, {
                // Use the new URL
                method: 'POST',
                // Remove the body as it's now in the query params
                // body: formDataVideo
            });

            if (!response.ok) {
                // Attempt to read the error message from the response body
                let errorMessage = `Video generation failed with status: ${response.status}`;
                try {
                    const errorData = await response.json();
                    // Assuming the error response has a 'message' or 'error' field
                    errorMessage =
                        errorData.message || errorData.error || JSON.stringify(errorData);
                } catch (jsonError) {
                    // If the response body is not JSON or empty, use the status text
                    errorMessage = `Video generation failed: ${response.status} ${response.statusText}`;
                }
                throw new Error(errorMessage);
            }

            const data = await response.json();
            setVideoUrl(data.video);
            AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.VIDEO_GENERATION_SUCCESS, {
                videoUrl: data.video,
                ip: ipData.ip,
            });
        } catch (err) {
            AnalyticsTracker.sendAnalyticsEvent(ANALYTICS_SOURCES.TRY_ON, EVENTS.VIDEO_GENERATION_ERROR, {
                errorMessage: err.message,
            });
            setVideoError(err.message);
        } finally {
            setVideoLoading(false);
            setShowLoader(false);
        }
    };

    return (
        <>
            <div className='logo-container'>
                <div
                    className='logo-container-logo'
                    onClick={() => {
                        AnalyticsTracker.sendAnalyticsEvent(
                            ANALYTICS_SOURCES.TRY_ON,
                            EVENTS.AVATAR_LOGO_CLICK
                        );
                        window.open('https://www.avataar.ai/', '_blank');
                    }}
                >
                    <Logo />
                </div>
                <button
                    className='contact-us-button'
                    onClick={() => {
                        AnalyticsTracker.sendAnalyticsEvent(
                            ANALYTICS_SOURCES.TRY_ON,
                            EVENTS.CONTACT_US_BUTTON_CLICK
                        );
                        window.open('https://www.avataar.ai/contact', '_blank');
                    }}
                >
                    Contact us
                </button>
            </div>
            <div className='page-title'>
                {titleData.title1} <span>{titleData.title2}</span>
            </div>

            <div className='content'>
                {/* Left Section - Upload */}
                <div className='upload-section'>
                    {/* <h1>Upload Image(s)</h1> */}

                    <label
                        htmlFor='file-input'
                        className={`upload-area ${loading ? 'disabled' : ''}`}
                        style={{ pointerEvents: loading ? 'none' : 'auto' }}
                    >
                        <input
                            type='file'
                            // multiple
                            accept='image/*'
                            onChange={handleFileChange}
                            className='file-input'
                            id='file-input'
                            disabled={loading}
                            ref={input1Ref}
                        />
                        <div className='upload-content'>
                            <LuUpload size={36} color='#2E62FF' />
                            <span className={`upload-text ${loading ? 'disabled' : ''}`}>
                                Upload Model Image
                            </span>
                        </div>
                    </label>

                    <label
                        htmlFor='file-input2'
                        className={`upload-area ${loading ? 'disabled' : ''}`}
                        style={{ pointerEvents: loading ? 'none' : 'auto' }}
                    >
                        <input
                            type='file'
                            // multiple
                            accept='image/*'
                            onChange={handleFileChangeForClothes}
                            className='file-input'
                            id='file-input2'
                            disabled={loading}
                            ref={input2Ref}
                        />
                        <div className='upload-content'>
                            <LuUpload size={36} color='#2E62FF' />
                            <span className={`upload-text ${loading ? 'disabled' : ''}`}>
                                Upload Garment Image
                            </span>
                        </div>
                    </label>
                    <div className='file-list-container'>
                    {files.length > 0 && (
                        <div className='file-list'>
                            <h3>Selected Model File:</h3>
                            <div className='preview-grid'>
                                {previews.map((preview, index) => (
                                    <div key={index} className='preview-item'>
                                        <img
                                            src={preview.url}
                                            alt={preview.name}
                                            className='preview-image'
                                        />
                                        <div className='preview-details'>
                                            <span className='preview-name'>{preview.name}</span>
                                            <button
                                                onClick={() => removeFile(index)}
                                                className='remove-button'
                                                disabled={loading}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {files2.length > 0 && (
                        <div className='file-list'>
                            <h3>Selected Garment File:</h3>
                            <div className='preview-grid'>
                                {previews2.map((preview, index) => (
                                    <div key={index} className='preview-item'>
                                        <img
                                            src={preview.url}
                                            alt={preview.name}
                                            className='preview-image'
                                        />
                                        <div className='preview-details'>
                                            <span className='preview-name'>{preview.name}</span>
                                            <button
                                                onClick={() => removeFileForClothes(index)}
                                                className='remove-button'
                                                disabled={loading}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    </div>

                    {files.length > 0 && files2.length > 0 && (
                        <button
                            onClick={handleUpload}
                            disabled={files.length === 0 || loading}
                            className='download-button generate-button'
                            style={{ width: '100%' }}
                        >
                            {loading ? 'Processing...' : 'Upload and Process'}
                        </button>
                    )}

                    {error && <div className='error-message'>{error}</div>}
                </div>

                {/* Right Section - Results */}
                {/* Right Section - Results */}
                <div className='results-section'>
                    <h1>Results</h1>

                    {loading ? (
                        <Loader
                            avtrLoader
                            label='Generating tryon image... This may take a minute'
                            theme='light'
                            textStyle={{
                                fontSize: '16px',
                                fontFamily: 'Helvetica Neue',
                                fontWeight: '200',
                            }}
                        />
                    ) : results.length > 0 ? (
                        results.map((result, index) => (
                            <div key={index}>
                                <div className='media-container'>
                                    <div className='media-header'>
                                        <h3>Image Preview</h3>
                                        <button
                                            className='download-button'
                                            onClick={() => {
                                                if (Array.isArray(window?.dataLayer)) {
                                                    window?.dataLayer?.push({
                                                        event: 'Try On Image Download Click',
                                                        element_id: 'download-tryon-image-button',
                                                    });
                                                }
                                                AnalyticsTracker.sendAnalyticsEvent(
                                                    ANALYTICS_SOURCES.TRY_ON,
                                                    EVENTS.DOWNLOAD_IMAGE
                                                );
                                                window.open(result.imageUrl, '_blank');
                                            }}
                                        >
                                            Download Image
                                        </button>
                                    </div>
                                    <img
                                        className='tryon-output-image'
                                        src={result.imageUrl}
                                        alt='Tryon Result'
                                    />

                                    <div className='media-container' style={{ marginTop: '20px' }}>
                                        {!videoUrl && !videoLoading && (
                                            <button
                                                onClick={handleGenerateVideo}
                                                className='download-button generate-button'
                                                style={{ width: '100%' }}
                                            >
                                                Generate Video
                                            </button>
                                        )}

                                        {videoLoading && (
                                            <Loader
                                                avtrLoader
                                                label='Generating video... Please wait'
                                                theme='light'
                                                textStyle={{
                                                    fontSize: '16px',
                                                    fontFamily: 'Helvetica Neue',
                                                    fontWeight: '200',
                                                }}
                                            />
                                        )}

                                        {videoError && (
                                            <div className='error-message'>{videoError}</div>
                                        )}

                                        {videoUrl && (
                                            <div>
                                                <div className='media-header'>
                                                    <h3>Video Preview</h3>
                                                    <button
                                                        className='download-button'
                                                        onClick={() => {
                                                            if (Array.isArray(window?.dataLayer)) {
                                                                window?.dataLayer?.push({
                                                                    event: 'Try On Video Download Click',
                                                                    element_id: 'download-tryon-video-button',
                                                                });
                                                            }
                                                            AnalyticsTracker.sendAnalyticsEvent(
                                                                ANALYTICS_SOURCES.TRY_ON,
                                                                EVENTS.DOWNLOAD_VIDEO
                                                            );
                                                            window.open(videoUrl, '_blank');
                                                        }}
                                                    >
                                                        Download Video
                                                    </button>
                                                </div>
                                                <video
                                                    controls
                                                    style={{
                                                        width: '50%',
                                                        marginTop: '10px',
                                                        marginLeft: '25%',
                                                    }}
                                                    src={videoUrl}
                                                    autoPlay
                                                    loop
                                                    controlsList="nodownload"
                                                >
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{ textAlign: 'center', color: '#666', fontWeight: '400' }}>
                            No results to display yet. Upload an image to see the preview.
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default MediaUploader;
